window.Branch = window.Branch || {};
window.Branch.product = window.Branch.product || {};

window.Branch.product.updateFeaturesSection = function(variant){
    let pdpFeaturesSections = document.querySelectorAll(".pdp-features");
    pdpFeaturesSections.forEach((pdpFeaturesSection) => {
        let allDefaultImages = pdpFeaturesSection.querySelectorAll(`.pdp-features__slide-media.pdp-features__slide-media--default`);
        let allDefaultSubtitles = pdpFeaturesSection.querySelectorAll(`.pdp-features__slide-subtitle.pdp-features__slide-subtitle--default`);

        allDefaultImages.forEach((defaultImage) => {
            defaultImage.style.display = "block"
          });
    
          allDefaultSubtitles.forEach((defaultSubtitle) => {
            defaultSubtitle.style.display = "block"
          })
    
    if(variant){
        let altVariantImages = pdpFeaturesSection.querySelectorAll(`.pdp-features__slide-media[data-variant-id="${variant.id}"]`);
        let allNonDefaultImages = pdpFeaturesSection.querySelectorAll(`.pdp-features__slide-media:not(.pdp-features__slide-media--default)`);
        
        let altVariantSubtitles = pdpFeaturesSection.querySelectorAll(`.pdp-features__slide-subtitle[data-variant-id="${variant.id}"]`);
        let allNonDefaultSubtitles = pdpFeaturesSection.querySelectorAll(`.pdp-features__slide-subtitle:not(.pdp-features__slide-subtitle--default)`);
        
  
     
        if(allNonDefaultImages.length > 0 ){
          allNonDefaultImages.forEach(( nonDefaultImage) => {
            nonDefaultImage.style.display = "none"
          })
        }
  
        if(allNonDefaultSubtitles.length > 0 ){
          allNonDefaultSubtitles.forEach(( nonDefaultSubtitle) => {
            nonDefaultSubtitle.style.display = "none"
          })
        }
        
        if(altVariantImages.length > 0){
          altVariantImages.forEach((altVariantImage) => {
            altVariantImage.parentElement.querySelectorAll('.pdp-features__slide-media').forEach((slideMedia) => {
              slideMedia.style.display = 'none';
            })
            altVariantImage.style.display = "block";
          })
        } 
  
        if(altVariantSubtitles.length > 0){
          altVariantSubtitles.forEach((altVariantSubtitle) => {
            altVariantSubtitle.parentElement.querySelectorAll('.pdp-features__slide-subtitle').forEach((slideSubtitle) => {
              slideSubtitle.style.display = 'none';
            })
            altVariantSubtitle.style.display = "block";
          })
        } 
    }

    })
}         

$(function(){
    const initPDPFeaturesSlider = function(event){
        let sliderContainers = document.querySelectorAll('.pdp-features__slider-container');

        sliderContainers.forEach((sliderContainer, index) => {
            let autoscroll = false;
            if(sliderContainer.getAttribute('data-enable-autoscroll') == "true"){
                let autoscrollInterval = parseInt(sliderContainer.getAttribute('data-autoscroll-interval')) * 1000;;
                autoscroll = {
                    delay: autoscrollInterval,
                    disableOnInteraction: true
                    }
            }

            let params = {};
            if(event == "gallery-open"){
                params = {
                    slidesPerView: 1,
                    zoom: true,
                    spaceBetween: 0,
                    freeMode: false,
                    autoplay: autoscroll
                    }
            }
            if(event == "load"){
                let sliderElement = sliderContainer.querySelector('.pdp-features__slider');
                params = {
                    slidesPerView: 1.33333333333,
                    spaceBetween: 20,
                    freeMode: false,
                    autoplay: autoscroll,
                    navigation: {
                        nextEl: sliderContainer.querySelector('.pdp-features__right-arrow.swiper-button-next'),
                        prevEl: sliderContainer.querySelector('.pdp-features__left-arrow.swiper-button-prev'),
                    },
                    breakpoints: {
                        600: {
                            slidesPerView: 2.5,
                            spaceBetween: 40,
                            freeMode: false,
                            autoplay: autoscroll,
                            navigation: {
                                nextEl: sliderContainer.querySelector('.pdp-features__right-arrow.swiper-button-next'),
                                prevEl: sliderContainer.querySelector('.pdp-features__left-arrow.swiper-button-prev'),
                            }
                        },
                        1024: {
                            slidesPerView: 3.5,
                            spaceBetween: 40,
                            freeMode: false,
                            autoplay: autoscroll,
                            navigation: {
                                nextEl: sliderContainer.querySelector('.pdp-features__right-arrow.swiper-button-next'),
                                prevEl: sliderContainer.querySelector('.pdp-features__left-arrow.swiper-button-prev'),
                            }
                        }
                    },
                        on: {
                            init: function(){
                                if(this && this.slides[this.activeIndex] && this.slides[this.activeIndex].querySelector('video')){
                                    if(window.Branch.functions.isTouchDevice() == true){
                                        this.slides[this.activeIndex].querySelector('video').play();
                                    }
                                }
                            },
                            activeIndexChange: function () {
                                if(window.Branch.functions.isTouchDevice() == true){
                                    this.slides.forEach((slide) => {
                                        if(slide.querySelector('video')){
                                            slide.querySelector('video').pause();
                                        }
                                        console.log('slide.classList', slide.classList.contains('swiper-slide-active'))
                                        // if(slide.classList.contains('swiper-slide-active')){
                                        //     slide.querySelector('video').play();
                                        // }
                                        
                                    })
                                    if(this && this.slides[this.activeIndex] && this.slides[this.activeIndex].querySelector('video')){
                                        this.slides[this.activeIndex].querySelector('video').play();
                                    }
                                }
                            }
                    }
                }
                var pdpFeaturesSwiper = new Swiper(sliderElement, params);
            }
        })
    }


    const initHoverVideoPlay = function(video){
        video.addEventListener('mouseenter', function() {
            video.play();
        });
        video.addEventListener('mouseleave', function() {
            video.pause();
        });    
    }

    const initVideos = function(){
        let videos = document.querySelectorAll('.pdp-features__slider-container video');
        videos.forEach((video) => {
            function addLoadedClass() {
                video.setAttribute('data-video-loaded', true);
            }
    
            if (video.readyState >= 2) {
                addLoadedClass();
            } else {
                video.addEventListener('loadeddata', addLoadedClass);
            }


            if(window.Branch.functions.isTouchDevice() == false){
                initHoverVideoPlay(video);
            }
        });
        videos.forEach((video) => {
            video.load();
        })
    }
    
    const initPDPFeatures = function(){
        initVideos();
        initPDPFeaturesSlider("load");
    }
    
    window.addEventListener('load', function(){
        initPDPFeatures();
    });
});
